'use strict';

angular.module('openDataApp')
  .controller('MenuCtrl', ['$scope', function ($scope) {
    $scope.section = 'main';
    if (window.location.pathname.split('/')[1] === 'dashboard') {
      $scope.section = 'dashboard';
    } else if (window.location.pathname.split('/')[1] === 'documentation') {
      $scope.section = 'documentation';
    } else if (window.location.pathname.split('/')[1] === 'support') {
      $scope.section = 'support';
    }
  }]);
